import { styled } from '@fv/design-tokens'

export const Header = styled.div`
  grid-area: videoHeader;
`
